<div class="frame-in ulitka">
    <div class="font-loader" style="font-family: 'Kids Rock DEMO';">1</div>
    <div class="font-loader" style="font-family: 'Beanstalker DEMO';">1</div>
    <div [ngClass]="{'hidden': loading}">
        <div id="game-container">

        </div>
    </div>
</div>